/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability for widgets that accept MenuId instead of a Menu widget. plied to the DOM.
 *
 * @module MW/toolstrip/mixins/property/MenuIdMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dijit/registry",
    "mw-form/Menu",
    "MW/toolstrip/widgets/gallery/GalleryPopup"
], function (declare, registry, Menu, GalleryPopup) {
    return declare(null, {
        menuId: '',

        _setMenuIdAttr: function (menuId) {
            this._set("menuId", menuId);
            this._syncAttributes();
        },

        // Override from MenuMixin to sync menuId and menu
        _setMenuAttr: function (menu) {
            this.set("menuId", menu.get("id"));
        },

        _getMenuIdAttr: function () {
            this._syncAttributes();
            return this._get("menuId");
        },

        _getMenuAttr: function () {
            this._syncAttributes();
            return this._get("menu");
        },

        _syncAttributes: function () {
            var menuIdWidget = registry.byId(this._get("menuId")) || null;

            // In Toolstrip the menuId property is the one which is used to set and get the menu,
            // so it is considered to be correct if the menu property and menuId property do not match.
            if (this._get("menu") !== menuIdWidget) {
                this._validateMenuAttr(menuIdWidget);
                this._set("menu", menuIdWidget);
            }
        }

    });

});
